var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxBg"},[_c('h4',[_vm._v(_vm._s(_vm.analysisData.title))]),_vm._l((_vm.analysisData.dataArrayList),function(item,index){return _c('p',{key:index},[_vm._v(_vm._s(item))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }